export default __webpack_public_path__ + "static/media/Biote_aqua.1720d59c.png";